<template>
  <div class="mobile-index">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="HQS AUTOMOTIVE"
      class="nav-bar"
      left-text=""
    >
      <!-- 自定义右侧退出图片 -->
      <template #right>
        <img 
          src="@/assets/quit.png" 
          class="quit-img"
          @click="outSys"
          alt="Logout"
        >
      </template>
    </van-nav-bar>

    <!-- 搜索区域 -->
    <div class="search-container">
      <van-search
        v-model="queryParams.sortNumber"
        placeholder="Sort No."
        class="search-input"
        @search="handleSearch"
        @clear="handleSearch"
        :show-action="false"
      />
      <van-button 
        type="primary" 
        class="search-btn"
        @click="handleSearch"
      >
        Search
      </van-button>
    </div>

    <!-- 列表区域 -->
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      class="list-container"
      pulling-text="Pull down to refresh"
      loosing-text="Release to refresh"
      loading-text="Refreshing..."
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="No more data"
        @load="onLoad"
        class="sort-list"
        :immediate-check="false"
        loading-text="Loading..."
      >
        <!-- 列表项 -->
        <van-cell
          v-for="(item, index) in SortData"
          :key="item.id"
          class="list-item"
          @click="handleItemClick(item)"
        >
          <div class="item-content">
            <div class="item-title">{{ item.objsortNumber }}</div>
            <div class="item-client">Client: {{ item.clientName || '—' }}</div>
            <div class="item-footer">
              <span class="status-tag" :class="getStatusTagClass(item.statusValue)">
                {{ item.statusValue || '—' }}
              </span>
              <span class="start-date">Start: {{ item.startDate || '—' }}</span>
            </div>
          </div>
          <!-- <van-icon name="arrow-right" color="#ccc" size="16"  /> -->
        </van-cell>

        <!-- 空数据提示 -->
        <div v-if="SortData.length === 0 && !loading" class="empty-tip">
          <van-empty description="No data, please try other criteria" />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import objstorage from "@/common/localstorage/storage.js";
import objaxios from "axios";
import objurl from "@/common/interface/url.js";

export default {
  name: "MobileIndex",
  data() {
    return {
      // User-related
      objuserinfo: {},
      showUserMenu: false,
      userMenuActions: [
        { name: "Account Info", icon: "user-o" }
      ],

      // List request parameters
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        sortNumber: ""
      },

      // List data
      SortData: [],
      objtotal: 0,
      loading: false,
      finished: false,
      refreshing: false
    };
  },
  created() {
    this.initUserInfo();
    this.getSortData();
  },
  methods: {
    /**
     * Initialize user info
     */
    initUserInfo() {
      const userInfo = objstorage.get("userinfo");
      if (userInfo && userInfo.user && userInfo.user.account) {
        this.objuserinfo = userInfo;
        this.userMenuActions[0].name = "Account: " + userInfo.user.account;
      } else {
        this.$router.replace("/");
        this.$toast.fail("Please log in first");
      }
    },

    /**
     * Handle user menu selection
     */
    handleUserMenuSelect(action) {
      this.showUserMenu = false;
      const account = this.objuserinfo && this.objuserinfo.user && this.objuserinfo.user.account;
      this.$dialog.alert({
        title: "Account Info",
        message: "Account: " + (account || "Unknown") + "\nLogin Time: " + new Date().toLocaleString()
      });
    },

    /**
     * Get sort list data
     */
    getSortData() {
      const tokenHead = this.objuserinfo && this.objuserinfo.tokenHead ? this.objuserinfo.tokenHead : "";
      const token = this.objuserinfo && this.objuserinfo.token ? this.objuserinfo.token : "";
      objaxios.defaults.headers.common["Authorization"] = tokenHead + token;

      this.loading = true;

      objaxios
        .post(objurl.sort_find_mobile, this.queryParams)
        .then((res) => {
          this.loading = false;
          this.refreshing = false;

          if (res.data.code === "200") {
            const resData = res.data.data || {};
            this.objtotal = Number(resData.total) || 0;

            const formatData = (resData.list || []).map((item) => {
              let objsortNumber = "—";
              if (item && item.sortTypeValue !== undefined && item.sortNumber) {
                objsortNumber = item.sortTypeValue === 2 
                  ? "SSORT" + item.sortNumber 
                  : "TSORT" + item.sortNumber;
              }
              return { ...item, objsortNumber };
            });

            if (this.refreshing) {
              this.SortData = formatData;
            } else {
              this.SortData = this.SortData.concat(formatData);
            }

            this.finished = this.SortData.length >= this.objtotal;
          } else if (res.data.code === "401") {
            this.$toast.fail(res.data.message || "Login expired, please log in again");
            objstorage.remove("userinfo");
            this.$router.replace("/");
          } else {
            this.$toast.fail(res.data.message || "Failed to get data");
          }
        })
        .catch((error) => {
          this.loading = false;
          this.refreshing = false;
          console.error("List request error: ", error);
          this.$toast.fail("Network error, please try again later");
        });
    },

    /**
     * Pull down to refresh
     */
    onRefresh() {
      this.queryParams.pageNum = 1;
      this.finished = false;
      this.SortData = [];
      this.getSortData();
    },

    /**
     * Pull up to load more
     */
    onLoad() {
      if (this.SortData.length >= this.objtotal) {
        this.finished = true;
        this.loading = false;
        return;
      }
      this.queryParams.pageNum += 1;
      this.getSortData();
    },

    /**
     * Handle search
     */
    handleSearch() {
      this.queryParams.pageNum = 1;
      this.finished = false;
      this.SortData = [];
      this.getSortData();
    },

    /**
     * Handle list item click (jump to detail)
     */
    handleItemClick(item) {
      this.$router.push({
        path: "/SortDetailMobile",
        query: { sortData: JSON.stringify(item) }
      });
    },

    /**
     * Log out system
     */
    outSys() {
      const tokenHead = this.objuserinfo && this.objuserinfo.tokenHead ? this.objuserinfo.tokenHead : "";
      const token = this.objuserinfo && this.objuserinfo.token ? this.objuserinfo.token : "";
      objaxios.defaults.headers.common["Authorization"] = tokenHead + token;

      objaxios
        .post(objurl.user_logout_mobile)
        .then((res) => {
          objstorage.remove("userinfo");
          this.$router.replace("/");
          this.$toast.success("Logout successful");
        })
        .catch((error) => {
          console.error("Logout request error: ", error);
          objstorage.remove("userinfo");
          this.$router.replace("/");
          this.$toast.success("Logout successful");
        });
    },

    /**
     * Get status tag class
     */
    getStatusTagClass(status) {
      const statusLower = status && typeof status === "string" ? status.toLowerCase() : "";
      switch (statusLower) {
        case "active":
          return "status-active";
        case "closed":
          return "status-closed";
        default:
          return "status-default";
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.mobile-index {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding-bottom: 20px;
  box-sizing: border-box;
}

/* 导航栏：100%宽度，标题居中，退出图片在最右侧 */
.nav-bar {
  background-color: #2a4062;
  color: #fff;
  height: 56px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  box-sizing: border-box;

  /deep/ .van-nav-bar__content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  /deep/ .van-nav-bar__title {
    color: #fff;
    font-weight: 500;
    font-size: 18px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    margin: 0;
    line-height: 56px;
  }

  /deep/ .van-nav-bar__right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;
    min-width: 24px;
    margin-left: auto;
    padding: 0;
  }

  /deep/ .van-nav-bar__left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    min-width: 24px;
    padding: 0;
  }
}

/* 退出图片样式 */
.quit-img {
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: block;
}

/* 搜索区域 */
.search-container {
  padding: 12px 16px;
  background-color: #fff;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
}

.search-input {
  flex: 1;
  /deep/ .van-search__content {
    background-color: #f5f7fa;
    border-radius: 8px;
    height: 40px;
  }
}

.search-btn {
  width: 80px;
  height: 40px;
  background-color: #2a4062;
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 2%;
}

/* 列表区域（分割线加深） */
.list-container {
  padding: 0 16px;
}

.sort-list {
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 列表项 */
.list-item {
  /deep/ .van-cell {
    border-bottom: 2px solid #e0e0e0;  /* 加深分割线 */
    padding: 0;
  }
  
  &:last-child /deep/ .van-cell {
    border-bottom: none;
  }

  .item-content {
    flex: 1;
    overflow: hidden;
    padding: 10px 16px;
  }

  .item-title {
    font-size: 16px;
    color: #2a4062;
    font-weight: 500;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item-client {
    font-size: 13px;
    color: #303133;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item-footer {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .status-tag {
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .status-active {
    background-color: #e8f5e9;
    color: #4caf50;
  }

  .status-closed {
    background-color: #ffebee;
    color: #f44336;
  }

  .status-default {
    background-color: #e3f2fd;
    color: #2196f3;
  }

  .start-date {
    font-size: 12px;
    color: #909399;
  }
}

/* Empty tip */
.empty-tip {
  padding: 40px 0;
  text-align: center;
}

/* 适配小屏手机 */
@media (max-width: 320px) {
  .item-title {
    font-size: 14px;
  }

  .search-btn {
    width: 70px;
    font-size: 13px;
  }
}

/* 适配大屏手机 */
@media (min-width: 414px) {
  .search-container {
    padding: 16px 20px;
  }

  .list-container {
    padding: 0 20px;
  }

  .item-title {
    font-size: 17px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/IndexMobile.vue